// generated from 217 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastNameFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_name_filter"),
  comparison_key: z.enum([
    "1", // 172 (79.26%)
    "11", // 23 (10.60%)
    "2", // 12 (5.53%)
    "10", // 5 (2.30%)
    "12", // 3 (1.38%)
    "17", // 2 (0.92%)
  ]),
  display_name: z.string(),
  // undefined: 63 (29.03%), defined 154 (70.97%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
